export default __webpack_public_path__ + "static/media/Search.9f92db09.svg";